module.exports = __webpack_public_path__ + "static/img/block6.8920121.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block6.png
// module id = SZ1y
// module chunks = 1